import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/poApprovalMatrix",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "poApprovalMatrix-page",
        component: () =>
          import("@/views/POApprovalMatrix/POApprovalMatrixPage.vue"),
        meta: {
          title: "PO Approval Matrix",
          titleLocalizationCode: "PO_Approval_Matrix",
          desc: "PO approval matrix page",
          descLocalizationCode: "PO_Approval_Matrix_Page",
          sidebarElement: false,
          permissionCodes: [
            "PO_ApprovalMatrix.Read",
            "PO_ApprovalMatrix.Add",
            "PO_ApprovalMatrix.Edit",
            "PO_ApprovalMatrix.Delete",
          ],
        },
      },
    ],
  },
];
